import { render, staticRenderFns } from "./CountingDiceDialog.vue?vue&type=template&id=45bee417&scoped=true"
import script from "./CountingDiceDialog.vue?vue&type=script&lang=js"
export * from "./CountingDiceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45bee417",
  null
  
)

export default component.exports